var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlockCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26880",
    "data-name": "Group 26880",
    transform: "translate(-536.493 -437.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26871",
    "data-name": "Group 26871",
    transform: "translate(-1006.57 -803.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1536",
    "data-name": "Ellipse 1536",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1543.063 1241.486)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_lock",
    "data-name": "vuesax/bold/lock",
    transform: "translate(437.493 130.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(108 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H12V12H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.738,3.382V4.435a6.456,6.456,0,0,0-.749-.05v-1C5.99,1.8,5.545.752,3.369.752S.749,1.8.749,3.382v1A6.456,6.456,0,0,0,0,4.435V3.382C0,1.929.349,0,3.369,0S6.738,1.929,6.738,3.382Z",
    transform: "translate(2.631 0.626)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.371.05A6.472,6.472,0,0,0,7.622,0H2.374a6.472,6.472,0,0,0-.75.05C.35.205,0,.832,0,2.506v1c0,2,.5,2.506,2.5,2.506h5c2,0,2.5-.5,2.5-2.506v-1C10,.832,9.646.205,8.371.05ZM3.354,3.362A.525.525,0,0,1,3,3.508a.5.5,0,0,1-.19-.04.516.516,0,0,1-.165-.105A.528.528,0,0,1,2.5,3.007a.5.5,0,0,1,.04-.19.579.579,0,0,1,.1-.165.516.516,0,0,1,.165-.105.5.5,0,0,1,.545.105.579.579,0,0,1,.1.165.5.5,0,0,1,.04.19A.528.528,0,0,1,3.354,3.362Zm2.1-.165a.579.579,0,0,1-.1.165A.525.525,0,0,1,5,3.508a.515.515,0,0,1-.355-.145.579.579,0,0,1-.1-.165.5.5,0,0,1-.04-.19.5.5,0,1,1,1,0A.5.5,0,0,1,5.458,3.2Zm1.894.165a.506.506,0,0,1-.71,0,.509.509,0,0,1,0-.712.522.522,0,0,1,.71,0c.02.025.04.05.06.08a.279.279,0,0,1,.045.085.319.319,0,0,1,.03.09.755.755,0,0,1,.01.1A.528.528,0,0,1,7.352,3.362Z",
    transform: "translate(1.002 4.984)",
    fill: "#424e55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockCircle);
export default __webpack_public_path__ + "static/media/padlock_circle.77002b4efd1df7d9338430c9586defbb.svg";
export { ForwardRef as ReactComponent };